import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Typography } from '@guildeducationinc/recess';
import { useGetS3Url, useLocale } from '../../hooks';
import { LoaderCircleIcon } from '../LoaderCircleIcon/LoaderCircleIcon';
import { PdfViewer } from '../PdfViewer';
import styles from './DocumentViewer.module.scss';
export const DocumentViewer = ({ doc }) => {
    const { t } = useLocale();
    const { s3Url, loading, error } = useGetS3Url({ s3Key: doc.s3Key, preview: true });
    const getExtn = (fileName) => {
        const extn = fileName.split('.').pop();
        return extn ? extn.toLowerCase() : '';
    };
    const isImage = (fileName) => {
        const extn = getExtn(fileName);
        return ['jpg', 'jpeg', 'png', 'gif'].includes(extn ? extn.toLowerCase() : '');
    };
    const renderDocument = (doc) => {
        if (isImage(doc.name)) {
            return _jsx("img", { src: s3Url, alt: doc.name });
        }
        // doc, docx will be converted to pdf for preview
        if (['pdf', 'doc', 'docx'].includes(getExtn(doc.name))) {
            return _jsx(PdfViewer, { url: s3Url });
        }
        // TODO - Need to check if using google docs viewer is fine
        // if (['doc', 'docx', 'xls', 'xlsx', 'csv'].includes(extn)) {
        //   return (
        //     <iframe
        //       title={doc.name}
        //       width='100%'
        //       height={750}
        //       // style={{ height: 500 }}
        //       src={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(url)}`}
        //     ></iframe>
        //   );
        // }
        return _jsx("div", { children: "Unsupported file type" });
    };
    if (!loading && !s3Url && !error) {
        return null;
    }
    return (_jsxs("div", { className: styles.docViewer, children: [!loading && error && (_jsx(Alert, { type: 'danger', display: true, hideClose: true, children: t('Error displaying document') })), loading && (_jsx("div", { className: 'text-center', children: _jsx(Typography, { variant: 'title3', children: _jsxs("span", { className: 'flex gap-2 items-center justify-center mb-2', children: [_jsx("span", { children: t('Generating preview... please wait') }), ' ', _jsx(LoaderCircleIcon, { fontSize: 'small' })] }) }) })), s3Url && renderDocument(doc)] }));
};
